import { ORIGIN_ID as EXPERIMENT_FILTER_ORIGIN } from "@eyeo-fragments/filter-experiments/shared";
export var FilterOrigin;
(function (FilterOrigin) {
    FilterOrigin["popup"] = "popup";
    FilterOrigin["web"] = "web";
    FilterOrigin["devtools"] = "devtools";
    FilterOrigin["wizard"] = "wizard";
    FilterOrigin["youtube"] = "youtube";
    FilterOrigin["customize"] = "customize";
    FilterOrigin["context"] = "context";
    FilterOrigin[FilterOrigin["experiment"] = EXPERIMENT_FILTER_ORIGIN] = "experiment";
})(FilterOrigin || (FilterOrigin = {}));
